import { Swap, Details } from '@velocity-exchange/icons';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import MobileTableCard from 'src/components/Tables/cards/MobileTableCard';
import TableV2 from 'src/components/Tables/TableV2';
import { AggregateLiqState } from 'src/hooks/Liquidations/useAggregateLiquidationDataForUser';

interface Props {
	liquidation: AggregateLiqState;
	toggleDateDisplayType: () => void;
	displayDatesAsTimestamp: boolean;
	showLiquidationDetailsDrawer: (liquidation: AggregateLiqState) => void;
}

export default function LiquidationsTableMobileCard({
	liquidation,
	toggleDateDisplayType,
	displayDatesAsTimestamp,
	showLiquidationDetailsDrawer,
}: Props) {
	return (
		<MobileTableCard.Root className="flex-row items-center gap-x-md">
			<div className="flex w-full justify-between">
				<MobileTableCard.LabelWithValue
					label={
						<>
							Time
							<IconButton
								size="sm"
								variant="tertiary"
								className="-m-md p-md"
								onClick={toggleDateDisplayType}
								icon={Swap}
							/>
						</>
					}
					value={
						<TableV2.DateCell
							className="w-fit py-0 whitespace-nowrap"
							displayAsTimestamp={displayDatesAsTimestamp}
							date={new Date(liquidation.ts * 1000)}
						/>
					}
				/>

				<MobileTableCard.LabelWithValue
					className="items-end"
					label="Debt Transferred"
					value={liquidation.notionalAmount.abs().toNotional(true)}
				/>
			</div>
			<IconButton
				size="sm"
				icon={Details}
				onClick={() => showLiquidationDetailsDrawer(liquidation)}
			/>
		</MobileTableCard.Root>
	);
}
